import React from "react";
import { Button, Modal } from "../../../../../../../components";

const AcceptTermsModal = ({ isOpen, onClose, onAccept }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Accept the terms of use"
      width="max-w-4xl"
    >
      <div className="p-1">
        <p className="bodytwo mb-4 text-bold">
          Before you proceed please accept the following terms:
        </p>
        <ul className="list-decimal list-inside space-y-2">
          <li>
            I understand that this is a complementary feature which accepts LCA
            PDF downloaded from DOL’s FLAG Portal only.
          </li>
          <li>
            I understand that this feature does not accept scanned documents.
          </li>
          <li>
            By using this feature I’m responsible for the data accuracy. I’ll
            review the data in the next step for it’s accuracy.
          </li>
        </ul>
        <div className="flex gap-4 mt-8 justify-end">
          <Button title="I Decline" onClick={onClose} variant="outlined" />
          <Button title="I Accept" onClick={onAccept} />
        </div>
      </div>
    </Modal>
  );
};

export default AcceptTermsModal;
